import UnpublishedQuestionOptionsSkeleton from './UnpublishedQuestionOptions/skeleton';

export interface QuestionOptionsSkeltonProps {
  className?: string;
}

const QuestionOptionsSkeleton = ({ className }: QuestionOptionsSkeltonProps) => {
  return <UnpublishedQuestionOptionsSkeleton className={className} />;
};

export default QuestionOptionsSkeleton;
